import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import AttendanceNavigation from "./AttendanceNavigation";

const { Content } = Layout;

function Attendance() {
	return (
		<Layout className="member-layout">
			<AttendanceNavigation />
			<Layout className="member-content-layout">
				<Content className="member-content">
					<Outlet />
				</Content>
			</Layout>
		</Layout>
	);
}

export default Attendance;
